/** Operator-facing labels — channel first (email), then purpose. */
const INTEGRATION_KEY_DISPLAY_LABELS = {
  'notifier.mail': 'Email · уведомление о протечке',
  'reporter.mail': 'Email · показания',
};

export function displayIntegrationLabel(key, fallbackName = null) {
  const normalized = String(key || '').trim();
  if (!normalized) {
    return fallbackName || '—';
  }
  return INTEGRATION_KEY_DISPLAY_LABELS[normalized] || fallbackName || normalized;
}

export function formatIntegrationsCell(facts = {}) {
  const keys = Array.isArray(facts.active_integration_keys) ? facts.active_integration_keys : [];
  const names = Array.isArray(facts.active_integration_names) ? facts.active_integration_names : [];
  if (keys.length > 0) {
    return keys
      .map((key, index) => displayIntegrationLabel(key, names[index] || null))
      .filter(Boolean)
      .join(', ');
  }
  if (facts.integration_key) {
    return displayIntegrationLabel(facts.integration_key, facts.integration_name || null);
  }
  if (names.length > 0) {
    return names.filter(Boolean).join(', ');
  }
  return facts.integration_name || '—';
}
